define([
  'es6!sumo/util',
  'immutable',
  'es6!launcher/actions/ListBuilderActions',
  'es6!launcher/util/listbuilder/constants',
], (Util, Immutable, Actions, Constants) => {
  const { FormTypes } = Constants;

  const initialState = Immutable.Map({
    modalBodyHeight: 0,
    // Keeps track of the currently selected component in the wysiwyg.
    wysiwygSelectedComponentId: null,
    // Keeps track of the currently hovered component in the wysiwyg.
    // The component about to be clicked..
    wysiwygHoveredComponentId: null,
    // Keeps track of which popup we are editing. subscribe, success, etc.
    wysiwygPopupMode: 'subscribe',
    // Keeps track of which responsive format we are editing. default, mobile, etc.
    wysiwygResponsiveFormat: 'default',
    // Whether we are in fullscreen mode for not.
    wysiwygFullscreen: false,
    // Shows or hide app modal
    hidden: false,
    // Importing legacy apps
    importSource: null,
    importingScrollBox: false,
    importingSmartBar: false,
    importingWelcomeMat: false,
    // Show or hide import modal
    importStatus: null,
    // Set default launch status for AppView (app entry point) to determine rerouting
    appViewLaunchedStatus: true,
  });

  const actionHandlers = {};

  actionHandlers[Actions.RESIZE_MODAL] = (state, action) => (
    state.set('modalBodyHeight', action.modalBodyHeight)
  );

  actionHandlers[Actions.UPDATE_APP_STATE] = (state, action) => (
    state.set(action.state, action.value)
  );

  actionHandlers[Actions.UPDATE_IMPORT_SOURCE] = (state, action) => {
    let newState = state.set('importSource', action.source);

    if (action.migrating && action.source === FormTypes.SCROLL_BOX) {
      newState = newState.set('importingScrollBox', true);
    }

    if (action.migrating && action.source === FormTypes.SMART_BAR) {
      newState = newState.set('importingSmartBar', true);
    }

    if (action.migrating && action.source === FormTypes.WELCOME_MAT) {
      newState = newState.set('importingWelcomeMat', true);
    }

    return newState;
  };

  actionHandlers[Actions.UPDATE_IMPORT_STATUS] = (state, action) => (
    state.set('importStatus', action.status)
  );

  actionHandlers[Actions.UPDATE_APPVIEW_LAUNCHED_STATUS] = (state, action) => (
    state.set('appViewLaunchedStatus', action.appViewLaunchedStatus)
  );

  return Util.createReducer(initialState, actionHandlers);
});
